import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import imagesLoaded from 'imagesloaded'

import { updateImageDisplays } from './../shared/image-displays'
import { initSwipeEvents } from './../shared/mobile'

class AmznController extends RytmWebflow.Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
    imagesLoaded(this.getContainerSelector(), $.proxy(this.amznLoadImagesComplete, this));
  }
  
  /**
  * on view shown - animation in / show complete
  * @param {Event} e
  **/
  onViewShown(e) {
    super.onViewShown(e)
    setTimeout(() => {
      updateImageDisplays()
    }, 500)
  }
  
  addEventListeners() {
    const swipe = document.querySelector('.item-nav-swipe')
    if (swipe) {
      initSwipeEvents(swipe)
    }
  }
  removeEventListeners() {
    
  }
  /**
   * ###########
   * ### OWN ###
   */
  amznLoadImagesComplete() {
    updateImageDisplays()
  }


}

export default AmznController;